import {
  IGrossProfitByTagSizeResponse,
  IGrossprofitReportResponse
} from '../../interfaces/grossprofit-report.interface'

export interface GrossprofitReportsStateModel {
  reports: IGrossprofitReportResponse
  grossProfitByTagSize: IGrossProfitByTagSizeResponse
}
